import { action, ActionType } from "typesafe-actions";

import { IError } from "../../../redux/actions/errorHandlingAction";
import { Nullable } from "../../../types/common";
import { SearchResults } from "../../../types/search/search-results.interface";
import { ICampaignBriefsResults } from "../../../types/search/icampaign-brief-results.interface";

import {
  ICampaignBriefsFilterOptions,
  ICampaignBriefsFilters,
} from "../types/campaign-briefs.interface";

export enum CampaignBriefsActions {
  ChangePage = "CampaignBriefs/ChangePage",

  Fetch = "CampaignBriefs/Fetch",
  FetchFailure = "CampaignBriefs/FetchFailure",
  FetchSuccess = "CampaignBriefs/FetchSuccess",

  FetchFilters = "CampaignBriefs/FetchFilters",
  FetchFiltersFailure = "CampaignBriefs/FetchFiltersFailure",
  FetchFiltersSuccess = "CampaignBriefs/FetchFiltersSuccess",
}

export const changePage = (filters: ICampaignBriefsFilters) =>
  action(CampaignBriefsActions.ChangePage, filters);

export const fetch = (filters: ICampaignBriefsFilters) =>
  action(CampaignBriefsActions.Fetch, filters);
export const fetchFailure = (error: Nullable<IError>) =>
  action(CampaignBriefsActions.FetchFailure, error);
export const fetchSuccess = (data: SearchResults<ICampaignBriefsResults>) =>
  action(CampaignBriefsActions.FetchSuccess, data);

export const fetchFilters = () => action(CampaignBriefsActions.FetchFilters);
export const fetchFiltersFailure = (error: Nullable<IError>) =>
  action(CampaignBriefsActions.FetchFiltersFailure, error);
export const fetchFiltersSuccess = (filterOptions: ICampaignBriefsFilterOptions) =>
  action(CampaignBriefsActions.FetchFiltersSuccess, filterOptions);

const actionCreators = {
  changePage,

  fetch,
  fetchFailure,
  fetchSuccess,

  fetchFilters,
  fetchFiltersFailure,
  fetchFiltersSuccess,
};

export type CampaignBriefsActionType = ActionType<typeof actionCreators>;
